import React, { createContext, useContext, ReactNode } from 'react';
import { useFCM } from '../../hooks/useFCM';

interface FCMContextValue {
  registerToken: () => Promise<void>;
}

const FCMContext = createContext<FCMContextValue | undefined>(undefined);

/**
 * Hook to access FCM registration from any child component.
 * Useful for triggering token sync when push preferences are enabled.
 */
export const useFCMContext = (): FCMContextValue => {
  const ctx = useContext(FCMContext);
  if (!ctx) throw new Error('useFCMContext must be used inside FCMProvider');
  return ctx;
};

interface FCMProviderProps {
  children: ReactNode;
}

export const FCMProvider: React.FC<FCMProviderProps> = ({ children }) => {
  const { registerToken } = useFCM();

  return (
    <FCMContext.Provider value={{ registerToken }}>
      {children}
    </FCMContext.Provider>
  );
};
